import { useThemeStore } from "@stores/theme.store";
import { Select } from "antd";
import { useEffect, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { Spiner } from "@components/loaders/spiner";
import { FcFinePrint } from "react-icons/fc";
import { studentDailyScores } from "@services/dtos/school.dto";
import { ActiveElementType } from "@services/dtos/general.dto";
import { MdKeyboardArrowRight } from "react-icons/md";
// moment.locale("id");
export const ReportCardDailyPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [activeCollapse, setActiveCollapse] = useState<ActiveElementType>(
    {} as ActiveElementType
  );
  const [semester, setSemester] = useState<string>("1");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [
      SchoolService.queries.GET_SCHOOL_STUDENT_DAILY_SCORES,
      nis,
      semester,
    ],
    queryFn: () => SchoolService.studentDailyScores({ nis, semester }),
  });

  const collapsibleView = (index: number) => {
    setActiveCollapse({
      active: index === activeCollapse.index ? !activeCollapse.active : true,
      index,
    });
  };

  const renderScoreRow = (
    keyVal: number | string,
    label: string,
    value: string | number | undefined
  ) => (
    <div
      className="tw-px-4 tw-py-2 tw-text-[#000] tw-bg-[#f9f9f9] tw-border-b-2"
      key={keyVal}
    >
      <div className="tw-py-2">
        <div className="tw-px-2 tw-flex tw-justify-between tw-items-start tw-font-semibold">
          <div className="tw-text-sm">{label}</div>
          <div className="tw-w-1/3 tw-text-end">
            <div className="tw-text-sm">{value ?? "-"}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const collapsibleContent =
    data?.data != null && data.data.length > 0
      ? data.data.map((item: studentDailyScores, idx: number) => {
          const dailyScores = Array.from({ length: 8 }, (_, i) =>
            renderScoreRow(
              i + 1,
              `Nilai Harian ${i + 1}`,
              item[`h${i + 1}` as keyof studentDailyScores]
            )
          );

          const examScores = Array.from({ length: 8 }, (_, i) =>
            renderScoreRow(
              i + 9,
              `Nilai Ujian ${i + 1}`,
              item[`u${i + 1}` as keyof studentDailyScores]
            )
          );

          return {
            header: (
              <div className="tw-w-full" key={idx}>
                <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                  <div className="tw-text-xs tw-font-medium tw-text-other-600">
                    Pelajaran
                  </div>
                </div>
                <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                  <div className="tw-text-sm">{item.namamapel}</div>
                </div>
              </div>
            ),
            children: (
              <>
                {dailyScores}
                {examScores}
              </>
            ),
          };
        })
      : [];

  useEffect(() => {
    setAppBar({ title: "Nilai Harian", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Nilai Harian",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">
              Filter Data (Berdasarkan Semester)
            </div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Semester"
              defaultValue={semester}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setSemester(e)}
              options={[
                { value: "1", label: "1" },
                { value: "2", label: "2" },
              ]}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan: semester {semester}
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card tw-mt-4">
            {isPending ? (
              <div className="tw-text-center tw-p-4">
                <Spiner />
              </div>
            ) : data?.message === "hidden" ? (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Nilai belum bisa ditampilkan</div>
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <>
                {collapsibleContent.map((view, index) => (
                  <div key={index}>
                    <div
                      className={`tw-py-3 tw-px-2.5 tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-t-1 tw-border-t-other-300 collapse-header tw-rounded-lg`}
                      onClick={() => {
                        collapsibleView(index + 1);
                      }}
                    >
                      <div className="tw-flex tw-justify-center tw-items-center collapse-header-box">
                        <MdKeyboardArrowRight
                          className={`collapse-header-icon ${
                            activeCollapse.active &&
                            activeCollapse.index === index + 1
                              ? "rotating"
                              : ""
                          }`}
                          size={20}
                        />
                        {view.header}
                      </div>
                    </div>

                    <div
                      className={`tw-text-sm tw-text-other-600 tw-bg-other-100 tw-border-b tw-border-other-300 collapse-content collapse-content-${index}`}
                      ref={contentRef}
                      style={{
                        maxHeight:
                          activeCollapse.active &&
                          activeCollapse.index === index + 1
                            ? `${contentRef.current?.scrollHeight}px`
                            : //   "max-content"
                              "0px",
                      }}
                    >
                      {view.children}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};
